module.exports = __webpack_public_path__ + "img/forte2.7e4f934e.jpeg";